export function feEnv(): { platform: 'web' | 'native'; mode: string; isProd: boolean; isDev: boolean } {
  return { platform: 'web', mode: import.meta.env.MODE, isProd: import.meta.env.PROD, isDev: import.meta.env.DEV }
}
